import { LightboxImage } from './Lightbox'

const StorySection = () => {
  return (
    <section id="about" className="relative w-full bg-[#0a0f1a] pt-20 md:pt-32 pb-10 md:pb-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black font-montserrat uppercase tracking-wide text-white leading-tight mb-3">
              Are You Wearing Cancer?
            </h2>
            <p className="text-red-500 text-3xl md:text-4xl font-montserrat font-bold uppercase tracking-wider mb-8">
              They Are.
            </p>

            <p className="text-white text-lg md:text-xl leading-relaxed font-poppins font-light mb-6">
              They charge into burning buildings. They wash other people's lives off the road. They come home, and they don't talk about it.
            </p>

            <p className="text-white text-base md:text-lg leading-relaxed font-poppins font-light mb-6">
              SPOKE lives inside the fire service. Through the young crew of Firehouse 13 in the US and three-time occupational cancer survivor Canadian Fire Captain Rudy Pospisil, cycling the globe while the clock ticks, the film asks the question the institution has avoided for decades: who saves the people who save everyone else?
            </p>

          </div>

          <div className="relative">
            <LightboxImage
              src="/spoke-static/images/SPOKE_film_firefighters_smoke_breathing_apparatus.jpg"
              alt="SPOKE film close-up of two firefighters surrounded by thick smoke, one wearing a breathing apparatus and helmet number 313"
              className="w-full rounded-lg shadow-2xl"
            />
            <div className="absolute inset-0 rounded-lg ring-1 ring-white/10 pointer-events-none"></div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default StorySection
